<template>
  <section class="anchors" ref="anchors">
    <div v-if="activeAccommodation && !isDestinationType" class="anchors__Wrapper">
      <div class="container">
        <div class="anchors__List">
          <button v-for="item in data.anchors" @click="scrollTo(item.anchor_id)" class="anchors__ListItem" :class="{ 'isActive': item.anchor_id === activeSectionId }">{{ item.title }}</button>
        </div>
  
        <div class="anchors__Right">
          <button v-if="activeAccommodation.gallery?.length" type="button" @click="open('gallery')" class="anchors__ActionButton">
            <Icon name="photo-gallery" />
          </button>
          <nuxt-link v-if="page.camp_map && Object.keys(page.camp_map)" :to="page.camp_map.sef" class="anchors__ActionButton">
            <Icon name="map" />
          </nuxt-link>
          <Button v-if="getAvailabilityDates(activeAccommodation.availability_calendar)" negative @click="goToUnitsListing">{{ $t('checkRates') }}</Button>
        </div>
      </div>
    </div>
  
    <template v-if="dialogs.gallery && !isDestinationType">
      <Teleport to="body">
        <Modal v-show="dialogs.gallery" v-model="dialogs.gallery" class="modal__Gallery">
          <template v-for="item in activeAccommodation.gallery">
            <FlarePicture v-if="item"
              :src="{
                1920: { src: item, width: 1000 },
              }"
              :alt="item.alt"
            />
            <p v-if="item.description" v-text="item.description" />
          </template>
        </Modal>
      </Teleport>
    </template>
  
    <div v-if="isDestinationType" class="anchors__PropertyWrapper">
      <div class="container">
        <h2 v-text="data.title" />
        <div class="anchors__PropertyList">
          <button v-for="item in data.anchors" @click="scrollTo(item.anchor_id)" :class="{ 'isActive': item.anchor_id === activeSectionId }">{{ item.title }}</button>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
  const props = defineProps({
    data: {},
  });
  const { page } = usePage();
  const { accommodationsData, link } = useSetup();
  const { getAvailabilityDates, updateSearchDates } = useAvailabilityDates();
  const anchors = ref(null);
  const scrollTimeout = ref(null);
  const lastScrollY = ref(0);

  const { elements } = useIntersectionObserver((entry) => {
    if (entry.isIntersecting) {
      activeSectionId.value = entry.target.id;
    }
  }, { threshold: 0, rootMargin: '-100px 0px -100px 0px' });
  const activeSectionId = ref(null);
  
  const activeAccommodation = computed(() => accommodationsData.value[page.value.id]);
  const isDestinationType = computed(() => props.data.type === 'destination');

  const dialogs = reactive({
    gallery: false
  });
  const { open } = useModal(dialogs);

  function scrollTo(id) {
    let element = document.querySelectorAll(`#${id}`)[0];
    if (element) {
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - 150;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  }

  function detectAnchorsPosition() {    
    if (window.innerWidth <= 768) {
      clearTimeout(scrollTimeout.value);
      scrollTimeout.value = setTimeout(() => {
        if (window.scrollY > anchors.value.clientHeight && window.scrollY > lastScrollY.value) {
          anchors.value.classList.add('anchors--Translate');
        } else {
          anchors.value.classList.remove('anchors--Translate');
        }
        lastScrollY.value = window.scrollY;
      }, 50);
    }
  }

  async function goToUnitsListing() {
    updateSearchDates(activeAccommodation.value.availability_calendar);
    await navigateTo({ path: link('AccommodationUnitList'), query: { accommodation_id: page.value.id } });
  }

  onMounted(() => {
    lastScrollY.value = window.scrollY;
    elements.value = document.querySelectorAll(props.data.type === 'property' ? '#__nuxt section' : '.features__Item');
    window.addEventListener('scroll', detectAnchorsPosition);
  })

  onBeforeUnmount(() => {
    window.removeEventListener('scroll', detectAnchorsPosition);
  })
</script>

<style lang="scss">
  @import url('@/assets/styles/components/blocks/_anchors.scss');
</style>